import React, {useState} from 'react';
import {useSelector} from 'react-redux';
import Plan from "./components/plan";
import Menu from '../menu';
import BuyOrUpgrade from './components/buy-or-upgrade';
import ProfileInfo from './components/profile-info';
import Icon from '../icon';
import Button from '../button';
import ContactSearch from './components/contact-search';
import SyncStatus from '../sync-status';
import "./index.css";

function Header () {

    const [extendMenu, setExtendMenu] = useState(false);

	const profile = useSelector(state => state.profileReducer.getProfile);
	const sharingPageReady = useSelector(state => state.profileReducer.sharingPageReady);

	const toggleMenu = () => {
		document.querySelectorAll('.extend').forEach( item => {
			item.classList.remove('extend');
		});

		setExtendMenu(!extendMenu);
	};

	const extendHandler = (boolean) => {
		setExtendMenu(boolean);
    };

    return (
        <div className="header">
	        {
		        window.innerWidth <= 992 && <div>
			        <Button onClick={ toggleMenu } className="menu-burger btn-link mr-auto">
			            <Icon name="bars"/>
			        </Button>
			        <div className="d-flex align-self-stretch">
			            <Menu extendMenu={extendMenu} extendHandler={extendHandler}/>
			        </div>
		        </div>
	        }
	        <div className="header__content">
		        <div className="d-flex flex-grow-1 align-items-center position-relative">
			        {
				        profile && sharingPageReady && <>
					        <SyncStatus/>
					        <ContactSearch/>
				        </>
			        }
		        </div>
		        <div className="d-flex align-items-center justify-content-end">
			        <Plan/>
			        {
				        profile && (
					        profile.role === "ADMINISTRATOR"
					        && (profile.domain.status !== "EVAL" && profile.domain.status !== "EXPIRED_EVAL")
				        ) && <BuyOrUpgrade/>
			        }
			        <ProfileInfo/>
		        </div>
	        </div>
        </div>
    );
}

export default Header;
